module.exports = __webpack_public_path__ + "img/risk.bef19068.png";